module.exports = __webpack_public_path__ + "img/noti-tick.539abe4c.svg";